import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import { getHelpDescription } from '../../utils/help/help-content';

const iconButtonStyle = { height: 30, padding: 8 };

export function PromptBulkActions({
  count,
  running,
  deleting,
  onRun,
  onDelete,
  className = 'mb-2',
}: {
  count: number;
  running: boolean;
  deleting: boolean;
  onRun: () => void;
  onDelete: () => void;
  className?: string;
}) {
  if (count === 0) return null;
  const busy = running || deleting;

  return (
    <div className={`d-flex gap-2 align-items-center ${className}`}>
      <ChildrensTooltip delayToRemove={0} placement="top" html={getHelpDescription('actions.run_selected_prompts')}>
        <Button
          style={iconButtonStyle}
          disabled={busy}
          onClick={onRun}
          variant="falcon-primary"
          size="sm"
          className="d-flex gap-1 align-items-center"
          aria-label="اجرای انتخاب‌شده‌ها"
        >
          <FontAwesomeIcon icon="play" className="fs-0" />
        </Button>
      </ChildrensTooltip>
      <ChildrensTooltip delayToRemove={0} placement="top" html={getHelpDescription('actions.delete_prompt')}>
        <Button
          style={{ height: 30, padding: 12 }}
          disabled={busy}
          onClick={onDelete}
          variant="danger"
          size="sm"
          className="d-flex gap-2 align-items-center"
          aria-label="حذف پرامپت"
        >
          <FontAwesomeIcon icon="trash-alt" className="fs-0" />
        </Button>
      </ChildrensTooltip>
    </div>
  );
}
